import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CementoVentaDto } from '../models/venta-cemento.dto';
import { ServerListQuery, ServerPaginatedResponse } from '../models/server-list.model';

@Injectable()
export class CementoVentaApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}cemento/cotizacion/`;

  listVentas(query: ServerListQuery): Observable<ServerPaginatedResponse<CementoVentaDto>> {
    const params = new HttpParams()
      .set('page', String(query.page))
      .set('page_size', String(query.pageSize))
      .set('search', query.search)
      .set('ordering', query.ordering);
    return this.http.get<ServerPaginatedResponse<CementoVentaDto>>(`${this.baseUrl}list_admin_ventas/`, { params });
  }

  exportExcel(query: ServerListQuery): Observable<Blob> {
    const params = new HttpParams()
      .set('search', query.search)
      .set('ordering', query.ordering);
    return this.http.get(`${this.baseUrl}export_excel_ventas/`, { params, responseType: 'blob' });
  }
}
